module.exports = __webpack_public_path__ + "media/Cancel.c95cba40.mp3";